var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMegago(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logomegago",
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.762,
    height: 43,
    viewBox: "0 0 111.762 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17",
    "data-name": "Trazado 17",
    d: "M38.7,123.565a4.342,4.342,0,0,1-5.648-2.145l-7.1-14.8a4.127,4.127,0,0,1,2.21-5.489,4.343,4.343,0,0,1,5.648,2.146L40.91,118.09a4.125,4.125,0,0,1-2.214,5.475m-14.205,0a4.342,4.342,0,0,1-5.648-2.145l-7.1-14.8a4.055,4.055,0,0,1-.081-3.144,4.21,4.21,0,0,1,2.289-2.345,4.344,4.344,0,0,1,1.572-.346h.024c.044,0,.088,0,.132,0s.088,0,.131,0h.024a4.344,4.344,0,0,1,1.572.346,4.207,4.207,0,0,1,2.289,2.345L26.7,118.088a4.127,4.127,0,0,1-2.213,5.477M12.507,121.42a4.341,4.341,0,0,1-5.648,2.145,4.126,4.126,0,0,1-2.214-5.477L8.574,109.9l4.73,9.856ZM44.84,116.4h0l-7.1-14.8a8.694,8.694,0,0,0-11.307-4.3,8.482,8.482,0,0,0-3.652,2.954l-.006.008a8.68,8.68,0,0,0-6.817-3.656h-.06c-.074,0-.148,0-.222,0s-.168,0-.252,0l-.076,0A8.6,8.6,0,0,0,7.819,101.6l-7.1,14.8a8.259,8.259,0,0,0,4.42,10.986,8.747,8.747,0,0,0,10.54-2.948,8.742,8.742,0,0,0,10.538,2.948,8.477,8.477,0,0,0,3.658-2.962,8.745,8.745,0,0,0,10.549,2.962A8.261,8.261,0,0,0,44.84,116.4",
    transform: "translate(0.007 -85.089)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18",
    "data-name": "Trazado 18",
    d: "M349.47,12.04V2.088A2.082,2.082,0,0,1,352.614.3L361,5.273a2.083,2.083,0,0,1,0,3.582l-8.389,4.976A2.082,2.082,0,0,1,349.47,12.04Z",
    transform: "translate(-307.798 -0.003)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19",
    "data-name": "Trazado 19",
    d: "M455.881,112.767h-6.587c-2.373,0-2.884,2.481-2.884,4.065l3.577-.021v2.109a7.784,7.784,0,0,1-3.565,1.005,8.668,8.668,0,0,1-4.411-1.376,6.257,6.257,0,0,1-2.745-5.561,6.6,6.6,0,0,1,6.259-6.936,5.6,5.6,0,0,1,5.2,2.465,2.886,2.886,0,0,0,3.867.678l2.531-1.636a2.9,2.9,0,0,0,1.273-1.9,2.831,2.831,0,0,0-.5-2.182,14.223,14.223,0,0,0-12.372-6.169,15.422,15.422,0,0,0-15.036,15.679,14.725,14.725,0,0,0,5.714,12.154,17.269,17.269,0,0,0,10.22,3.527A17.578,17.578,0,0,0,456.683,125a5.274,5.274,0,0,0,2.084-4.22v-5.134A2.887,2.887,0,0,0,455.881,112.767Z",
    transform: "translate(-379.158 -85.707)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20",
    "data-name": "Trazado 20",
    d: "M699.995,97.89c-8.3,0-15.044,7-15.044,15.608s6.749,15.61,15.044,15.61,15.043-7,15.043-15.61S708.29,97.89,699.995,97.89ZM706.4,113.5c0,3.865-2.875,7.009-6.409,7.009s-6.41-3.144-6.41-7.009,2.875-7.008,6.41-7.008S706.4,109.634,706.4,113.5Z",
    transform: "translate(-603.276 -86.218)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegago);
export default __webpack_public_path__ + "static/media/megago.14c20b379a7cd0eab97681c69ed79513.svg";
export { ForwardRef as ReactComponent };